import person_1 from "../images/person_1.jpg";
import person_2 from "../images/person_2.jpg";
import person_3 from "../images/person_3.jpg";
import person_4 from "../images/person_4.jpg";

export const testimonials = [
  {
    name: 'Mukul Sarkar',
    image: person_1,
    feedback:
      "I was unable to walk due to my knee pain. So I went to this rehabilitation centre for knee physiotherapy. It's like a miracle now I am able to walk properly. The doctor and helpers are so much cordial and experienced. It is the best rehabilitation centre I ever went to.",
  },
  {
    name: 'Rakesh Verma',
    image: person_2,
    feedback:
      "I had vertigo issue for last 5-6 years. I come to know about this place from my friend. I visited from Mumbai chembur to this place for two weeks for treatment but I got recovered in 5 seatings. Mr Abhijit is master in his field and he know exactly what is required to do. Thanks to Mr. Abhijit Maji. And thanks to my friend Diptiman who advised me to visit this place.",
  },
  {
    name: 'Sunanda Chattopadhyay',
    image: person_3,
    feedback:
      "Abhijit Maji - a properly educated physiotherapist, at the same time a friendly and most importantly encouraging person to whom you can talk frankly about your problem. He will help you in every way to solve your problem. You can surely rely on him. In Bengali 'Chokh bondho kore bhorsa kora jay'.",
  },
  {
    name: 'Diptiman Bhattacharya',
    image: person_4,
    feedback:
      "Mr. Maji is awesome. My father suddenly became quadriplegic around 2 years back. Since then he is under the treatment of Mr. Maji and he got rid of many of other problems as well. We have witnessed many miracles to happen not only with my father but also with many of my family and friends, under the treatment of Mr. Maji. He has extensive experience in physiotherapy, osteopathy and myofascialtherapy. We never knew the name and advantages of osteopathy and myofascialtherapy earlier. In layman term these are the other techniques of adjust muscles, bone, nerves etc. Mr. Maji is an expert in these techniques which clearly makes him different and effective than other physiotherapy professional. Lastly he is a honest person, who does not unnecessarily drags the treatment for his own interest. Trust me, take only couple of session with him and you will feel the difference.",
  },
  {
    name: 'Tarun Singha',
    image: person_1,
    feedback:
      "Realey good analysis to diseases...& Fully carefull each patient very seriously...I am also a patient....& very very happy with treatment...",
  },
  {
    name: 'Surajit Paul',
    image: person_2,
    feedback:
      "Thanks to Dr Abhijit Majhi to set up such a physiotheraphy centre that helps us too much, also I got a nice treatment from him couple of months ago. Thanks again...",
  },
  {
    name: 'Mahadeb Neogi',
    image: person_3,
    feedback:
      "This is best chamber , good atmosphere and well modern equipment...I get good success ...just few month before I fell foot drop problem....after good treatment now I am completely cure ...thank to REALIGN HEALTHCARE .....and also many many thank to DR ABHIJIT SIR",
  },
  {
    name: 'Akhileshwar Pandey',
    image: person_4,
    feedback:
      "Best place to visit for chiropractic treatment here in serampore and adjoining areas.",
  },
  {
    name: 'Pushpa Verma Bhagat',
    image: person_1,
    feedback:
      "I was suffering from backpain and I went to orthopaedic doctor and he prescribed me with a belt. I wore it for 2 years and he also told me that I couldn't sit on the floor and bend down. Then I visited Dr.Majhi. In 10 seatings I was fully recovered and my belt was removed and I was able to do everything that I wasn't allowed to do. He is master and truly a magician in his field. Thanks to Dr. Abhijit Majhi! ",
  },
  {
    name: 'Punam Verma',
    image: person_1,
    feedback:
      "He is too good and honest person in his field. He fixed my left hand pain",
  },
  {
    name: 'Sourav Maji',
    image: person_2,
    feedback:
      "Highly recommended",
  },
  {
    name: 'Shatadur Gupta',
    image: person_3,
    feedback:
      "The Best....Fixed my back ache I was suffering from for almost 2 years.",
  },
  {
    name: 'Pallab Chakraorty',
    image: person_4,
    feedback:
      "You can avail very good clinical eye....",
  },
  {
    name: 'Rajkumar Chatterjee',
    image: person_1,
    feedback:
      "I used to feel like I was getting a shock of a current in my head for about a year and it used to happen 5 to 6 times. I went to many Dr. Dekh but it did not go away. Dr. Majii has cured me. His treatment is very good. He is the Best Physiotherapist and Osteoarthritis of Serampore i.e. West Bengal. If you want to cure your disease without taking medicine then go to him and your disease will get cured.",
  },
  {
    name: 'Chiranjeet Dey',
    image: person_2,
    feedback:
      "I had tendon repair surgery on my leg, since then Dr. Maji did my physiotherapy treatment and benefited a lot from her. A patient always expects good treatment from Dr. Babu, which I always get.",
  },
  {
    name: 'Nibedita Bhowmick',
    image: person_3,
    feedback:
      "I could not have imagined that I would be able to stand up so quickly, it would not have been possible without Dr. Babu's treatment. Thank you doctor.",
  },
];